import styled from 'styled-components';

export const FormContainer = styled.div`
    //max-width: 456px;
    width: 100%;
    margin: 16px auto 0;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    border-radius: 20px;
    border: 1px solid ${(props) => props.theme.palette.secondaryA14};

    .button-spinner svg {
        color: ${(props) => props.theme.palette.primaryA7};
    }
    .MuiFormHelperText-root {
        bottom: -17px;
    }
    .text {
        text-align: center;
    }
    .submit-button {
        width: max-content;
        margin: 0 auto;
    }
`;

export const FormTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SuccessContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    .success-icon {
        width: 64px;
        height: 64px;
        color: ${(props) => props.theme.palette.secondaryA3};
    }
`;

export const SuccessContainerTitle = styled.h3`
    ${(props) => props.theme.typography.h3};
    color: ${(props) => props.theme.palette.textMain};
`;

export const ErrorContainerTitle = styled.h3`
    ${(props) => props.theme.typography.h3};
    color: ${(props) => props.theme.palette.secondaryA4};
    text-align: center;
`;
